
define('text!fusion/ui/controls/fusion-pagemessage.html',[],function () { return '<div class="error-global" \r\n    data-bind="html: $parent.pageMessageHtml, css: { validationElement: $parent.pageMessageHtml }"></div>';});

